import { ApplicationRef, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, Injector, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { InputErrorStateMatcher, GlobalFunctions, GlobalConstantsSonstige } from 'globales-projekt-angular';
import { Guid } from 'guid-typescript';
import { FilterAuspRowComponent } from 'src/app/components/blocks/filter/filter-ausp-row/filter-ausp-row.component';
import { FilterWertRowComponent } from 'src/app/components/blocks/filter/filter-wert-row/filter-wert-row.component';
import { UebersichtTabelleComponent } from 'src/app/components/blocks/uebersicht-tabelle/uebersicht-tabelle.component';
import { FilterAuspRow } from 'src/app/data/klassen/filter-ausp-row.model';
import { FilterWertRow } from 'src/app/data/klassen/filter-wert-row.model';
import { UserGebaeudeFilter } from 'src/app/data/user/user-gebaeude-filter.model';
import { Gebaeude } from 'src/app/data/ws/dbKlassen/gebaeude.model';
import { ModulAuspraegungPrFilter } from 'src/app/data/ws/modul/modul-auspraegung-pr-filter.model';
import { ApiService } from 'src/app/services/api.service';
import { LocalService } from 'src/app/services/local.service';
import { ModalYesNoDialogComponent } from '../modal/modal-yes-no-dialog/modal-yes-no-dialog.component';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';
@Component({
  selector: 'app-auswahl',
  templateUrl: './auswahl.component.html',
  styleUrls: ['./auswahl.component.css']
})
export class AuswahlComponent implements OnInit {
  position = new FormControl(GlobalConstantsSonstige.POSITION_OPTIONS[0]);

  matcher: InputErrorStateMatcher = new InputErrorStateMatcher();

  gebklasseFormControl: FormControl = new FormControl(null);
  tierkategorieFormControl: FormControl = new FormControl(null);
  tierkategorieText!: string;

  //  childGuidUebersichtTable: Guid[] = [];

  childRefUebersichtTableMap: Map<boolean, ComponentRef<UebersichtTabelleComponent>> = new Map<boolean, ComponentRef<UebersichtTabelleComponent>>();

  childGuidFilterWertRow: Guid[] = [];
  childRefFilterWertRow: ComponentRef<FilterWertRowComponent>[] = [];

  childGuidFilterAuspRow: Guid[] = [];
  childRefFilterAuspRow: ComponentRef<FilterAuspRowComponent>[] = [];

  selectedGebaeudeList: Gebaeude[] = [];

  isSelectedGebaeudeExpandet: boolean = true;
  isMatExpansionVisible: boolean = false;

  selectedTabIndex: number = 0;
  anzahlGebaeudeTierartTk: number = 0;


  constructor(
    private apiService: ApiService,
    public localService: LocalService,
    private cfr: ComponentFactoryResolver,
    private dialog: MatDialog,
    private injector: Injector,
    private appRef: ApplicationRef
  ) { }

  ngOnInit(): void {
    if (!this.localService.fromErgebnis.value) {
      this.subscribeGebaeube();
    } else {
      //   this.setPageBackValue();
    }

  }



  subscribeGebaeube() {
    if (this.localService.userGebaeudeFilterSubscription.value) return;

    this.localService.userGebaeudeFilterSubscription.next(true);

    this.localService.userGebaeudeFilter.subscribe((userGebaeudeFilter) => {


      if (userGebaeudeFilter != null) {
        this.localService.mainComponentRef.value?.waitingForDataSpinner(true);

        this.apiService
          .postModAuspPrFilter(userGebaeudeFilter!)
          .subscribe((response) => {
            this.localService.modulAuspraegungPrFilter.next(response);

            if (this.localService.isNewTierart.value == true) {
              this.clearOldData(false);

              this.createSplitAndNewFilter(
                response,
                GlobalConstantsSonstige.DOM_CONTENT_DATEN_1,
                GlobalConstantsSonstige.DOM_CONTENT_DATEN_2
              );

              this.localService.isNewTierart.next(false);
            }

            this.getGebaeudeUebersicht(response.snr);

            if (this.localService.selectedGebaeudeList.value.length != 0) {
              this.selectedGebaeudeList =
                this.localService.selectedGebaeudeList.value;
              this.createNewTable(
                this.selectedGebaeudeList,
                GlobalConstantsSonstige.DOM_CONTENT_DATEN_5,
                false,
                []
              );
            }

            this.localService.mainComponentRef.value?.waitingForDataSpinner(false);
          });


      }
    });
  }

  createSplitAndNewFilter(
    modulAuspraegungPrFilter: ModulAuspraegungPrFilter,
    domContentWert: string,
    domContentAusp: string
  ) {
    if (modulAuspraegungPrFilter.modulPrWertFilterList.length > 0) {
      let filterWertRow!: FilterWertRow;

      modulAuspraegungPrFilter.modulPrWertFilterList.forEach((g, index) => {
        if (index % 2 === 0) {
          filterWertRow = new FilterWertRow();
          filterWertRow.modulPrWertFilterLinks = g;
        } else {
          filterWertRow.modulPrWertFilterRechts = g;
          this.createFilterWertRow(filterWertRow, domContentWert);
        }
      });

      if (filterWertRow.modulPrWertFilterRechts == null)
        this.createFilterWertRow(filterWertRow, domContentWert);
    }

    if (modulAuspraegungPrFilter.modulPrAuspFilterList.length > 0) {
      let filterAuspRow!: FilterAuspRow;

      modulAuspraegungPrFilter.modulPrAuspFilterList.forEach((g, index) => {
        if (index % 2 === 0) {
          filterAuspRow = new FilterAuspRow();

          filterAuspRow.modulPrAuspFilterLinks = g;
        } else {
          filterAuspRow.modulPrAuspFilterRechts = g;
          this.createFilterAuspRow(filterAuspRow, domContentAusp);
        }
      });

      if (filterAuspRow.modulPrAuspFilterRechts == null)
        this.createFilterAuspRow(filterAuspRow, domContentAusp);
    }
  }

  createFilterWertRow(filterWertRow: FilterWertRow, domElement: string) {


    // Erstelle die Komponente
    let filterDatentabelle: ComponentFactory<FilterWertRowComponent> =
      this.cfr.resolveComponentFactory(FilterWertRowComponent);
    let componentRef: ComponentRef<FilterWertRowComponent> =
      filterDatentabelle.create(this.injector);

    // Setze Werte und füge die Komponente zur DOM hinzu
    let id: Guid = Guid.create();
    //    this.childGuidUebersichtTable.unshift(id);

    componentRef.instance.id = id;
    componentRef.instance.parentMainComponent = this;
    componentRef.instance.setVariablen(filterWertRow);

    this.childRefFilterWertRow.unshift(componentRef);

    this.appRef.attachView(componentRef.hostView);
    let domElem: Node = (componentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;

    // Finde das Ziel-DOM-Element und ersetze es durch die neue Komponente
    let targetElement = document.getElementById(domElement);
    if (targetElement) {
      targetElement.appendChild(domElem);
    }

    componentRef.instance.createSubTables();
  }

  createFilterAuspRow(filterAuspRow: FilterAuspRow, domElement: string) {


    // Erstelle die Komponente
    let filterDatentabelle: ComponentFactory<FilterAuspRowComponent> =
      this.cfr.resolveComponentFactory(FilterAuspRowComponent);
    let componentRef: ComponentRef<FilterAuspRowComponent> =
      filterDatentabelle.create(this.injector);

    // Setze Werte und füge die Komponente zur DOM hinzu
    let id: Guid = Guid.create();
    //    this.childGuidUebersichtTable.unshift(id);

    componentRef.instance.id = id;
    componentRef.instance.parentMainComponent = this;
    componentRef.instance.setVariablen(filterAuspRow);

    this.childRefFilterAuspRow.unshift(componentRef);

    this.appRef.attachView(componentRef.hostView);
    let domElem: Node = (componentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;

    // Finde das Ziel-DOM-Element und ersetze es durch die neue Komponente
    let targetElement = document.getElementById(domElement);
    if (targetElement) {
      targetElement.appendChild(domElem);
    }

    componentRef.instance.createSubTables();
  }

  createNewTable(gebaeude: Gebaeude[], domContent: string, isAdd: boolean, selectedGebaeudeIds: number[]) {
    // Erstelle die Komponente
    let gebaeudeDatentabelle: ComponentFactory<UebersichtTabelleComponent> =
      this.cfr.resolveComponentFactory(UebersichtTabelleComponent);
    let componentRef: ComponentRef<UebersichtTabelleComponent> =
      gebaeudeDatentabelle.create(this.injector);

    // Setze Werte und füge die Komponente zur DOM hinzu
    let id: Guid = Guid.create();
    // this.childGuidUebersichtTable.unshift(id);

    componentRef.instance.id = id;
    componentRef.instance.parentMainComponent = this;
    componentRef.instance.setVariablen(gebaeude, isAdd, selectedGebaeudeIds);

    this.childRefUebersichtTableMap.set(isAdd, componentRef);

    this.appRef.attachView(componentRef.hostView);
    let domElem: Node = (componentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;

    // Finde das Ziel-DOM-Element und ersetze es durch die neue Komponente
    let targetElement = document.getElementById(domContent);
    if (targetElement) {
      targetElement.innerHTML = ''; // Leere das Ziel-DOM-Element
      targetElement.appendChild(domElem);
    }
  }



  getGebaeudeUebersicht(snr: number) {
    this.localService.mainComponentRef.value?.waitingForDataSpinner(true);
    this.apiService.postGebaeudeUebersicht(snr).subscribe((response) => {
      this.localService.foundGebaeudeList.next(response);


      for (const entry of response) {
        if (entry.dateiList && entry.dateiList.length > 0) {

          entry.dateiList[0].base64Image = GlobalFunctions.getUrlForFile(
            entry.dateiList[0].mimetype,
            entry.dateiList[0].datei
          );
        }
      }

      this.createNewTable(
        response,
        GlobalConstantsSonstige.DOM_CONTENT_DATEN_3,
        true, []
      );

      this.localService.mainComponentRef.value?.waitingForDataSpinner(false);
    });
  }

  changeGebKlasseTierkategorie(): Promise<boolean> {

    return new Promise((resolve) => {


      if (this.selectedGebaeudeList.length === 0) {

        resolve(true);
      } else {

        const dialogRef = this.dialog.open(ModalYesNoDialogComponent, {
          width: GlobalConstantsSonstige.BREITE_MODAL_KLEIN,
          disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (result > 0) {
            this.onRemoveAllEntrys(null);
            resolve(true);
          } else {
            resolve(false);
          }
        });
      }
    });
  }

  onSelectGebklasse(istGebaeude: boolean) {

    this.changeGebKlasseTierkategorie().then((isValid) => {
      if (!isValid) {
        // Auswahl abbrechen, indem das gebklasseFormControl zurückgesetzt wird
        this.gebklasseFormControl.setValue(!this.gebklasseFormControl.value);

        return;
      }

      this.localService.istGebaeude.next(istGebaeude);
      this.setGebKlasseTierkategorie(istGebaeude);
    });
  }

  setGebKlasseTierkategorie(istGebaeude: boolean) {
    this.localService.selectedtierkategorieList.next(this.localService.tierkategorieList.value.filter(
      (item) => item.istGebaeude === istGebaeude
    ));

    this.tierkategorieText = istGebaeude ? ConstantsTexte.BAULICHE_ANLAGE_WAEHLEN : ConstantsTexte.TIERKATEGORIE_WAEHLEN;
    this.tierkategorieFormControl.setValue(null);
    this.isMatExpansionVisible = false;
    this.clearOldData(true);
  }

  onSelectTierkategorie(idPr: number) {
    this.changeGebKlasseTierkategorie().then((isValid) => {
      if (!isValid) {
        // Auswahl abbrechen, indem das gebklasseFormControl zurückgesetzt wird
        this.tierkategorieFormControl.setValue(
          this.localService.userGebaeudeFilter.value?.idPr
        );

        return;
      }

      this.localService.kgeList.next([]);
      this.localService.selectedKgeList.next([]);

      this.anzahlGebaeudeTierartTk = this.anzahlGebaeudeTierartTk = this.localService.selectedtierkategorieList.value.find(pr => pr.idPr === idPr)!.anzahl;
      this.localService.isNewTierart.next(true);
      let userGebaeudeFilter: UserGebaeudeFilter = new UserGebaeudeFilter();
      userGebaeudeFilter.idPr = idPr;

      this.localService.userGebaeudeFilter.next(userGebaeudeFilter);
      this.clearOldData(true);
      this.isMatExpansionVisible = true;
    });
  }

  addSelectedEntry(gebaeude: Gebaeude) {
    if (
      this.selectedGebaeudeList.find(
        (g) => g.idGebaeude === gebaeude.idGebaeude
      )
    ) {
      return;
    }

    this.selectedGebaeudeList.push(gebaeude);
    this.selectedGebaeudeList.sort((a, b) =>
      a.bezeichnung.localeCompare(b.bezeichnung)
    );

    this.createNewTable(
      this.selectedGebaeudeList,
      GlobalConstantsSonstige.DOM_CONTENT_DATEN_5,
      false, []
    );

    this.localService.selectedGebaeudeList.next(this.selectedGebaeudeList);
  }

  onRemoveAllEntrys(event: MouseEvent | null) {
    if (event != null) event.stopPropagation();

    // "Mutating-while-iterating"-Falle durch duplizieren der Liste.
    this.selectedGebaeudeList.slice().forEach((entry) => {
      this.removeSelectedEntry(entry);
    });

  }

  removeSelectedEntry(gebaeude: Gebaeude) {
    this.childRefUebersichtTableMap.get(true)?.instance.added.set(gebaeude.idGebaeude, false);

    this.selectedGebaeudeList.splice(
      this.selectedGebaeudeList.findIndex(
        (g) => g.idGebaeude === gebaeude.idGebaeude
      ),
      1
    );

    if (this.selectedGebaeudeList.length == 0) {
      document.getElementById(
        GlobalConstantsSonstige.DOM_CONTENT_DATEN_5
      )!.innerHTML = '';

    } else {
      this.createNewTable(
        this.selectedGebaeudeList,
        GlobalConstantsSonstige.DOM_CONTENT_DATEN_5,
        false, []
      );
    }

    this.localService.selectedGebaeudeList.next(this.selectedGebaeudeList);
  }

  onAddAllEntrys(event: MouseEvent) {
    event.stopPropagation();

    const componentRef: ComponentRef<UebersichtTabelleComponent> | undefined = this.childRefUebersichtTableMap.get(true);
    if (componentRef) {
      this.localService.foundGebaeudeList.value.forEach(gebaeude => {
        componentRef.instance.addEntry(gebaeude);
      });
    }
  }

  clearOldData(removeEntrys: boolean) {
    if (this.isMatExpansionVisible) {

      document.getElementById(
        GlobalConstantsSonstige.DOM_CONTENT_DATEN_1
      )!.innerHTML = '';
      document.getElementById(
        GlobalConstantsSonstige.DOM_CONTENT_DATEN_2
      )!.innerHTML = '';
      document.getElementById(
        GlobalConstantsSonstige.DOM_CONTENT_DATEN_3
      )!.innerHTML = '';
      document.getElementById(
        GlobalConstantsSonstige.DOM_CONTENT_DATEN_5
      )!.innerHTML = '';
    }

    //    this.childGuidUebersichtTable = [];
    this.childRefUebersichtTableMap = new Map<boolean, ComponentRef<UebersichtTabelleComponent>>();

    this.childGuidFilterWertRow = [];
    this.childRefFilterWertRow = [];

    this.childGuidFilterAuspRow = [];
    this.childRefFilterAuspRow = [];

    if (removeEntrys) {
      this.localService.foundGebaeudeList.next([]);
      this.selectedGebaeudeList = [];

      this.localService.selectedGebaeudeList.next([]);
    }
  }

  onTabChange(event: MatTabChangeEvent) {
    this.selectedTabIndex = event.index;
  }
}
